import { Box } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';
import { de } from 'date-fns/locale/de';
import { Outlet, ScrollRestoration } from 'react-router';

import { BackendReachable } from './BackendReachable';
import { Footer } from './Footer';
import { Header } from './Header';
import { VivaSnackbarProvider } from './VivaSnackbarProvider';
import { WithAuth } from './WithAuth';

export const LayoutWithAuth = () => (
  <WithAuth>
    <VivaSnackbarProvider>
      <BackendReachable>
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <Header />
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={de}>
            <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
              <Box sx={{ flexGrow: 1, mx: { xs: 3, lg: 6 }, mb: { xs: 3, lg: 6 } }}>
                <Outlet />
              </Box>
              <ScrollRestoration />
              <Footer />
            </Box>
          </LocalizationProvider>
        </Box>
      </BackendReachable>
    </VivaSnackbarProvider>
  </WithAuth>
);
